import { useState } from "react";

const useFetchGet = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchData = async (url, data) => {
		setLoading(true);
		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error("Network response was not ok");
			}

			const responseData = await response.json();
			setLoading(false);
			return responseData;
		} catch (error) {
			setLoading(false);
			setError(error);
		}
	};

	return { fetchData, loading, error };
};

export default useFetchGet;



// WEBPACK FOOTER //
// ./src/components/crm/hooks/useFetchGet.js